import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../../../utils/TestIds';
import { Column } from '../../../Layout';
import { Typography } from '../../../Typography';
import { WithInfoIcon } from '../../../WithInfoIcon';
import { RowTransition } from '../../tableCore/RowTransition/RowTransition';
import styles from '../../tableCore/table.module.scss';
import { summaryCells } from '../summaryCells/summaryCells';
export function StaticTableSummaryRow(param) {
    let { summary, columns, minWidth, testId } = param;
    var _label_info;
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    const { offset, label, gap, amount } = summaryCells({
        columns,
        summary
    });
    return /*#__PURE__*/ _jsx(RowTransition, {
        entering: summary.entering === true,
        children: /*#__PURE__*/ _jsx("div", {
            className: cn(styles.rowCard, styles.summary, styles.summaryRowCard),
            style: {
                minWidth
            },
            "data-entering": summary.entering === true ? true : undefined,
            "data-testid": testIds.summary(summary.id),
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.row, styles.summaryRow),
                children: [
                    offset > 0 && /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: offset
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.rowCell, styles.summaryCell, styles.alignEnd),
                        style: {
                            width: label.width
                        },
                        "data-testid": testIds.summaryLabel(summary.id),
                        children: /*#__PURE__*/ _jsxs(Column, {
                            gap: 2,
                            width: "100%",
                            alignItems: "end",
                            children: [
                                /*#__PURE__*/ _jsx(WithInfoIcon, {
                                    info: (_label_info = label.info) !== null && _label_info !== void 0 ? _label_info : '',
                                    showInfo: label.info != null,
                                    size: "s",
                                    infoTestId: testIds.summaryInfo(summary.id),
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        weight: summary.weight,
                                        align: "right",
                                        breakWords: true,
                                        children: label.text
                                    })
                                }),
                                label.caption != null && /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph3",
                                    skin: "secondary",
                                    breakWords: true,
                                    align: "right",
                                    testId: testIds.summaryCaption(summary.id),
                                    children: label.caption
                                })
                            ]
                        })
                    }),
                    gap > 0 && /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: gap
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.rowCell, styles.summaryCell, styles.summaryAmountCell, styles.alignEnd),
                        style: {
                            width: amount.width
                        },
                        "data-testid": testIds.summaryAmount(summary.id),
                        children: /*#__PURE__*/ _jsx(Typography, {
                            weight: summary.weight,
                            children: amount.text
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.trailingGutter
                    })
                ]
            })
        })
    });
}
